<!--
 * @Author: Cathy
 * @Date: 2020-02-25 10:18:50
 * @LastEditors: yezi
 * @LastEditTime: 2020-06-23 17:28:20
 * @Description: 使用视频
 -->
<template>
  <div class="useVideo">
    <topMenu type="video"
             pageType="recommend" />
    <catalogue :list="list" />
    <div class="detail">
      <div class="detailItem"
           v-for="(item, index) in list"
           :key="index"
           @click="videoDetail(item)">
        <img :src="item.video_page" />
        <!-- <video :class="item.video_type === 2 ? 'videoJust' : 'videoWide'" :src="item.sources" controls="controls" controlslist="nodownload" playsinline :poster="item.video_page" /> -->
        <a :id="'title'+ index" />
        <p>{{index + 1}}.{{item.title}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import topMenu from '../components/topMenu'
import catalogue from '../components/catalogue'
import { getList } from '../api/wap'
export default {
  name: 'useVideo',
  components: {
    topMenu,
    catalogue
  },
  data () {
    return {
      list: [],
      isVertical: false
    }
  },
  created () {
    this.onLoadData()
  },
  methods: {
    onLoadData () {
      getList({ type: 1 })
        .then(res => {
          this.list = res.result.list
        })
    },
    videoDetail (e) {
      // console.log(11, e)
      // console.log(e.instructions_id)
      this.$router.push({
        path: '/videoDetail',
        // query: {
        //   sources: e.sources,
        //   title: e.title,
        //   video_page: e.video_page
        // }
        query: {
          id: e.instructions_id
        }
      })
    }
  }
}
</script>

<style scoped>
.detail {
  padding: 0.2rem 0 1rem;
  margin: 0 0.1rem;
  display: flex;
  flex-wrap: wrap;
}
.detailItem {
  margin-top: 0.59rem;
  width: 3.45rem;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
}
.detailItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0.2rem 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.detailItem img {
  /* margin-top: 0.3rem; */
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
.videoJust {
  width: 7.1rem;
  height: 7.1rem;
}
.videoWide {
  width: 7.1rem;
  height: 4rem;
}
</style>
